import React from 'react';
import { CheckIcon } from 'lucide-react';
import { audienceItems, timeValueTasks } from '../data/hockey';
export function Audience() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-17" data-mp="3p26xwg8xvpss">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12" data-id="element-18" data-mp="6vsj6f2ujbtc">
        <div className="lg:col-span-7" data-id="element-19" data-mp="1vwjut53g8k4">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-20" data-mp="1u38x1ng726b">
            Who Is <em className="text-red-700" data-id="element-21" data-mp="gr2ll3x5pl7n">HOCKEY READY™</em> For?
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-slate-900/75" data-id="element-22" data-mp="bt12wk3n7nwp">This Bundle Is for You If You:</p>
          <ul className="mt-8 grid gap-x-8 border-t border-slate-900/15 sm:grid-cols-2" data-id="element-23" data-mp="pkpi4w96ushw">
            {audienceItems.map(item => <li key={item} className="flex gap-3 border-b border-slate-900/10 py-4 leading-snug text-slate-900/80" data-id="element-24" data-mp="llqf5h70p5t3">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-25" data-mp="ukbvd5p0o8qp" />
                {item}
              </li>)}
          </ul>
          <p className="mt-8 font-serif text-xl italic leading-snug text-slate-900/80" data-id="element-26" data-mp="16eswkwma7o5v">
            Created for field hockey coaches who want to spend less time planning and more time coaching.
          </p>
        </div>

        <aside className="self-start rounded-3xl bg-slate-900 p-8 text-stone-50 sm:p-11 lg:col-span-5" data-id="element-27" data-mp="1gdigsw1nhkpa">
          <h3 className="font-serif text-3xl leading-tight sm:text-4xl" data-id="element-28" data-mp="1pbu68uqs6cg5">What Is Your Time Worth?</h3>
          <p className="mt-4 leading-relaxed text-stone-50/75" data-id="element-29" data-mp="1uax9qar44am0">
            Think about how many hours you spend planning practices each week:
          </p>
          <ul className="mt-5 divide-y divide-white/10 border-y border-white/10" data-id="element-30" data-mp="1z25mngrnie3x">
            {timeValueTasks.map(task => <li key={task} className="py-3 text-[15px] text-stone-50/85" data-id="element-31" data-mp="23zxb20t37i3d">
                {task}
              </li>)}
          </ul>
          <p className="mt-6 leading-relaxed text-stone-50/75" data-id="element-32" data-mp="2d1esbmi8dptn">
            Now imagine having an organized plan that handles all of this — for your whole season.
          </p>
          <p className="mt-4 font-serif text-xl italic leading-snug text-red-300" data-id="element-33" data-mp="cx2t3h1yvy71">
            You don’t have to keep starting from zero.
          </p>
        </aside>
      </div>
    </section>;
}